import {
  get,
  post,
  postForFileAsResponse,
  getForFileAsResponse,
  deleteApi,
} from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

export const getDocumentSharingInfoService = docID =>
  new Promise((resolve, reject) => {
    get(`${APIS.SHARE_DOCUMENT}/${docID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateDocumentSharingService = (docID, payload) =>
  new Promise((resolve, reject) => {
    post(`${APIS.SHARE_DOCUMENT}/${docID}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const addSharedDocumentComment = data =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SHARED_DOCUMENTS}/${data.docID}/${data.sharingHash}/comments`,
      data.note,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          "sharedDocumentServices => addSharedDocumentComment",
          error,
        );
        reject(error);
      });
  });

export const getSharedDocument = async (
  docID,
  sharingHash,
  fetchFields = true,
) => {
  const documentData = await get(
    `${
      APIS.SHARED_DOCUMENTS
    }/${docID}/${sharingHash}?fetch_fields=${fetchFields}`,
  )
    .then(res => {
      if (!res.Document) {
        return new Error("Invalid response. 'Document' key is necessary");
      }
      return res.Document;
    })
    .catch(error => {
      console.error("sharedDocumentServices => getSharedDocument", error);
      throw error;
    });
  return documentData;
};

export const getSharedDocumentV2 = async (
  docID,
  sharingHash,
  fetchFields = true,
) => {
  const documentData = await get(
    `${
      APIS.SHARED_DOCUMENTS_V2
    }/${docID}/${sharingHash}?fetch_fields=${fetchFields}`,
  )
    .then(res => {
      if (!res.DocInfo.document) {
        return new Error("Invalid response. 'Document' key is necessary");
      }
      return res;
    })
    .catch(error => {
      console.error("sharedDocumentServices => getSharedDocument", error);
      throw error;
    });
  return documentData;
};

export const getSharedDocumentComments = (docID, sharingHash) =>
  new Promise((resolve, reject) => {
    get(
      `${
        APIS.SHARED_DOCUMENTS
      }/${docID}/${sharingHash}/comments?object_type=CONTRACT&object_id=${docID}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          "sharedDocumentServices => getSharedDocumentComments",
          error,
        );
        reject(error);
      });
  });

export const exportSharedDocument = (
  exportType,
  exportContent,
  docID,
  sharingHash,
) =>
  new Promise((resolve, reject) => {
    postForFileAsResponse(
      `${
        APIS.SHARED_DOCUMENTS_V2
      }/${docID}/${sharingHash}/export/${exportType}`,
      exportContent,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteSharedDocumentServices = sharingHash =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ACCESS_CONTROLS}?share_hash=${sharingHash}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error("sharedDocumentServices => deleteSharedDocument", error);
        reject(error);
      });
  });

export const getUserByEmail = (searchedContent, isExternalUsersIncluded) =>
  new Promise((resolve, reject) => {
    get(
      `${
        APIS.USERS
      }?mailNameContains=${searchedContent}&external_included=${isExternalUsersIncluded}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`sharedDocumentServices => getUserByEmail => ${error}`);
        reject(error);
      });
  });

export const getUserByEmailV2 = (searchedContent, isExternalUsersIncluded) =>
  new Promise((resolve, reject) => {
    get(
      `${
        APIS.USERS_V2
      }?mailNameContains=${searchedContent}&external_included=${isExternalUsersIncluded}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`sharedDocumentServices => getUserByEmail => ${error}`);
        reject(error);
      });
  });

export const sharedDocAccepAndSign = (docId, sharinghash) =>
  new Promise((resolve, reject) => {
    post(`${APIS.SHARED_DOCUMENTS}/${docId}/${sharinghash}/signature`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(
          `sharedDocumentServices => sharedDocAccepAndSign => ${error}`,
        );
        reject(error);
      });
  });

export const sharedDocAfterAccepAndSign = (docId, sharinghash) =>
  new Promise((resolve, reject) => {
    get(`${APIS.SHARED_DOCUMENTS}/${docId}/${sharinghash}/signingurl`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(
          `sharedDocumentServices => sharedDocAfterAccepAndSign => ${error}`,
        );
        reject(error);
      });
  });

export const getSharedDocInPdf = (docId, sharingHash) =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(
      `${APIS.SHARED_DOCUMENTS}/${docId}/${sharingHash}/signed`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getSharedPermaLinkDocument = (sharingHash, docName) =>
  new Promise((resolve, reject) => {
    get(`${APIS.PERMA_DOC}/${sharingHash}/${docName}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const generateSignedPermaView = (sharingHash, docName) =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(`${APIS.PERMA_DOC}/${sharingHash}/${docName}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/SharedDocumentActions/sharedDocumentServices.js